import { useTypedQuery } from "hooks";
import { QRLoginQueryKeys } from "modules/Login/components/QrLogin/queryKeys";
import { ApiInstance } from "utils/Api";

export const useGenerateQRCodeQuery = () =>
  useTypedQuery({
    queryKey: QRLoginQueryKeys.qrCode,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.qr_code,
    enabled: false
  });
